import { getRgObjectsOfType as r, RG_TYPE as f } from "@project-rouge/rg-core";
import { getLevelGIA as s } from "../level-metrics/index20.js";
import { getNIA as c } from "./index38.js";
const p = (i) => {
  let t = 0;
  const n = r(i, f.Building);
  for (const o of n) {
    const l = new Set(o.data.levels.filter((e) => !e.isPodium && !e.isRoof).map((e) => e.levelIndex));
    for (const e of l)
      t += s(o, e);
  }
  return t === 0 ? 0 : c(i) / t;
};
export {
  p as getResidentialEfficiency
};
//# sourceMappingURL=index45.js.map
